import { render, staticRenderFns } from "./CodePromoItem.vue?vue&type=template&id=f304e56c&"
import script from "./CodePromoItem.vue?vue&type=script&lang=js&"
export * from "./CodePromoItem.vue?vue&type=script&lang=js&"
import style0 from "./CodePromoItem.vue?vue&type=style&index=0&id=f304e56c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports